import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const NAV_LINKS = [
  { label: "Trips", href: "/#trips" },
  { label: "Availability", href: "/#availability" },
  { label: "Vouchers", href: "/#vouchers" },
  { label: "Merch", href: "/#merch" },
  { label: "Gallery", href: "/gallery" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const go = (href) => {
    setOpen(false);
    if (href.startsWith("/#")) {
      navigate("/");
      setTimeout(() => document.getElementById(href.slice(2))?.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      navigate(href);
    }
  };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/shande-logo.png" alt="Shande III logo" className="h-11 w-11 rounded-full object-contain" />
          <span className="font-display text-2xl font-extrabold uppercase tracking-tight text-slate-900">
            Shande <span className="text-sky-500">III</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" data-testid="nav-links">
          {NAV_LINKS.map((l) => (
            <button key={l.label} data-testid={`nav-link-${l.label.toLowerCase()}`} onClick={() => go(l.href)}
              className="rounded-full px-4 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-sky-50 hover:text-sky-700">
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Button data-testid="nav-book-button" onClick={() => navigate("/book")}
            className="btn-lift hidden rounded-full bg-sky-500 px-5 font-semibold text-white hover:bg-sky-600 sm:inline-flex">
            Book a Trip
          </Button>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} className="rounded-lg p-2 text-slate-700 md:hidden" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white px-4 py-3 md:hidden" data-testid="nav-mobile-menu">
          {NAV_LINKS.map((l) => (
            <button key={l.label} data-testid={`nav-mobile-${l.label.toLowerCase()}`} onClick={() => go(l.href)}
              className="block w-full rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-700 hover:bg-sky-50">
              {l.label}
            </button>
          ))}
          <Button data-testid="nav-mobile-book-button" onClick={() => { setOpen(false); navigate("/book"); }}
            className="mt-2 w-full rounded-full bg-sky-500 font-semibold text-white hover:bg-sky-600">
            Book a Trip
          </Button>
        </div>
      )}
    </header>
  );
}
